export const navList = [
  {
    key: "home",
    name: "概况",
    icon: 'ed-home',
    path: "/home",
    children: [
      { path: "/home", name: "" },
      { path: "/home/todolist", noRender: true, name: "待办事项" },
      { path: "/home/studentdetail", noRender: true, name: "学员详情" },
      { path: "/home/useragreement", noRender: true, name: "用户协议" },
      { path: "/home/privateagreement", noRender: true, name: "隐私声明" },
      { path: "/home/childagreement", noRender: true, name: "儿童隐私保护协议" },
      { path: "/home/cluedetail", noRender: true, name: "线索详情" },
      { path: "/home/datadetails", noRender: true, name: "数据详情" },
      { path: "/home/cloudDiskStorage", noRender: true, name: "云盘存储" },

    ]
  },
  {
    key: "sale",
    name: "销售",
    icon: 'ed-sale',
    children: [
      { path: "/sale", icon: 'ed-sub-sale', name: "全部线索" },
      { path: "/sale/potential", icon: 'ed-sub-potential', name: "潜在学员" },
      { path: "/sale/prospective", icon: 'ed-sub-prospective', name: "意向学员" },
      { path: "/sale/member", icon: 'ed-sub-reading', name: "在读学员" },
      { path: "/sale/publicpool", icon: 'ed-sub-publicpool', name: "公有池" },
      { path: "/sale/auditionrecord", icon: 'ed-sub-audition', name: "试听记录" },
      { path: "/sale/order", icon: 'ed-sub-order', name: "订单" },
      { path: "/sale/merchandiseReturn", noRender: true, name: "商品退费" },
      { path: "/sale/studentdetail", noRender: true, name: "学员详情" },
      { path: "/sale/cluedetail", noRender: true, name: "线索详情" },
    ],
  },
  {
    key: "student",
    name: "学员",
    icon: 'ed-student',
    children: [
      { path: "/student", icon: 'ed-sub-student', name: "学员管理" },
      { path: "/student/renewal", icon: 'ed-sub-renewal', name: "即将续费学员" },
      { path: "/student/record", icon: 'ed-sub-record', name: "查询记录" },
      { path: "/student/studentdetail", noRender: true, name: "学员详情" },
    ],
  },
  {
    key: "education",
    name: "教务",
    icon: 'ed-education',
    children: [
      { path: "/education", icon: 'ed-sub-education', name: "课程管理" },
      { path: "/education/package", icon: 'ed-sub-package', name: "套餐管理" },
      { path: "/education/class", icon: 'ed-sub-class', name: "班级/一对一" },
      { path: "/education/lessons", icon: 'ed-sub-lessons', name: "补课管理" },
      { path: "/education/classroom", icon: 'ed-sub-classroom', name: "教室管理" },
      { path: "/education/arranging", icon: 'ed-sub-arranging', name: "排课管理" },
      { path: "/education/myarranging", icon: 'ed-sub-arranging', name: "我的课表" },
      { path: "/education/record", icon: 'ed-sub-class-record', name: "上课记录" },
      { path: "/education/myrecord", icon: 'ed-sub-myrecord', name: "我的上课记录" },
      { path: "/education/classdetail", noRender: true, name: "班级详情" },
      { path: "/education/bookingManage", icon: 'ed-sub-appointment-management', name: "约课管理" },
      { path: "/education/recordingLessons", icon: 'ed-sub-recording', name: "记上课" },
      { path: "/education/faceAttendance" ,icon: 'ed-sub-faceAttendance', name: "刷脸考勤" },
      { path: "/education/addStudentScheduling" , name: "添加学员" },
      { path: "/education/joinTheClass" , name: "加入班级" },
      { path: "/education/batchPromotion" , name: "批量升班" },



    ],
  },
  {
    key: "school",
    name: "家校",
    icon: 'ed-school',
    children: [
      { path: "/school", icon: 'ed-sub-school', name: "家校通知" },
      { path: "/school/show", icon: 'ed-sub-show', name: "兴趣秀" },
      { path: "/school/credits", icon: 'ed-sub-credits', name: "兴趣分" },
      { path: "/school/classFeedback", icon: 'ed-sub-classFeedback', name: "课堂反馈" },
      { path: "/school/studentdetail", noRender: true, name: "学员详情" },
      // { path: "/school/growthPortfolio", icon: 'ed-sub-classFeedback', name: "成长档案" },
    ],
  },
  {
    key: "data",
    name: "数据",
    icon: 'ed-data',
    children: [
      { path: "/data", icon: 'ed-sub-data', name: "消课记录" },
      { path: "/data/analysis", icon: 'ed-sub-analysis', name: "数据分析" },
      { path: "/data/attendanceRecord", icon: 'ed-sub-attendance_record', name: "签到记录" },
      { path: "/data/retentionOrLoss", icon: 'ed-sub-retention-or-loss', name: "留存/流失" },

    ],
  },{
    key: "internalmanagement",
    name: "内部",
    icon: 'ed-internal_management',
    children: [
      { icon: 'ed-sub-accounting', name: "手动记账", path: "/internalmanagement/accounting" },
      { icon: 'ed-sub-arrears-management', name: "欠费管理", path: "/internalmanagement/arrearsManagement" },
      { icon: 'ed-sub-commodity-management', name: "商品管理", path: "/internalmanagement/commodityManagement" },
      { icon: "ed-sud-salary", path: "/internalmanagement/SalaryPerformance"  , name: "工资绩效" },
      { path: "/internalmanagement/SalaryDetails" , name: "工资绩效" },
    ],
  },

  {
    key: "setting",
    name: "设置",
    icon: 'ed-setting',
    children: [
      { icon: 'ed-sub-setting', name: "机构信息", path: "/setting" },
      { icon: 'ed-sub-role', name: "角色管理", path: "/setting/role" },
      { icon: 'ed-sub-employee', name: "员工管理", path: "/setting/employee" },
      { icon: 'ed-sub-base', name: "基础设置", path: "/setting/base" },
      { icon: 'ed-sub-tags', name: "标签设置", path: "/setting/tags" },
      { icon: 'ed-sub-set-credits', name: "积分设置", path: "/setting/credits" },
      { icon: 'ed-sub-end', name: "结业设置", path: "/setting/end" },
      { icon: 'ed-sub-appointment-settings', name: "预约设置", path: "/setting/booking" },
      { icon:'ed-sub-school-setup',name:'学校设置',path:"/setting/schoolmanagement"},
      { icon:'ed-sub-comment-settings',name:'评语设置',path:"/setting/commentSettings"},
    ],
  },
];
